import React, {useEffect,useState}  from 'react';
import GConf from '../../AssetsM/generalConf';
import SubNav from '../Assets/subNav';
import { _ } from "gridjs-react";
import axios from 'axios';
import { Fade } from 'react-reveal';
import SKLT from '../../AssetsM/usedSlk';
import TableGrid from '../Assets/tableGrid';
import TableImage from '../Assets/tableImg';
import GoBtn from '../Assets/goBtn';
import { toast } from 'react-toastify';
import { Button , Icon, Modal} from 'semantic-ui-react';
import { useNavigate} from 'react-router-dom';


function FacturePage() {
    /*#########################[Const]##################################*/
    const navigate = useNavigate();
    const [facturesList, setFactureList] = useState([SKLT.TableSlt]); 
    let Offline = JSON.parse(localStorage.getItem(`${GConf.PID}_Offline`));
    const [modalS, setModalS] = useState(false)
    const [selectedArticle, setSelectedArticle] = useState([])
    const [tranchesListe, setTranchesListe] = useState([])

    /*#########################[UseEffect]##################################*/
    useEffect(() => {
        axios.post(`${GConf.ApiLink}/tools/facture-resumer`, {
            PID : GConf.PID,
        })
        .then(function (response) {
            setTranchesListe(response.data.Tranches)
            let factureListContainer = []
            let tranchesListeComing = response.data.Tranches
            response.data.Factures.map( (getData) => factureListContainer.push([
            _(<TableImage image='facture.jpg' />),
            getData.T_ID,
            getData.CL_Name,
            // new Date(getData.T_Date).toLocaleDateString('fr-FR').split( '/' ).reverse( ).join( '-' ),
            getData.Final_Value,
            getData.Reste,
            CalculateReste(tranchesListeComing,getData.T_ID, getData.Final_Value),
            _(<StateCard Reste={parseFloat(getData.Reste)} RealReste={CalculateReste(tranchesListeComing,getData.T_ID, getData.Final_Value)} />),
             
            _(<Button disabled={getData.Reste == CalculateReste(tranchesListeComing,getData.T_ID, getData.Final_Value)} className='rounded-pill bg-system-btn' size='mini' onClick={ (e) => UpdateRealStock(getData.T_ID,CalculateReste(tranchesListeComing,getData.T_ID, getData.Final_Value))}><span className='d-none d-lg-inline'> Update </span><Icon  name='angle right' /></Button>),
             _(<Button className='rounded-pill bg-system-btn' size='mini' onClick={ (e) => NavigateFunction(`/S/ft/info/${getData.T_ID}`)}><span className='d-none d-lg-inline'> Info </span><Icon  name='angle right' /></Button>)
            ],))
            setFactureList(factureListContainer)
        }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5> Les Donnée importeé sont les ancien donneé</div></>, GConf.TostInternetGonf) 
               
            }
          });
    }, [])
    
    

    /*#########################[Function]##################################*/
    const NavigateFunction = (link) => {  navigate(link) }
    const openEditModal = (event,selected) =>{
        setSelectedArticle(event)
        setModalS(true)
    }
    const CalculateReste = (Liste, FactID, realTot) => {
      let TranchesAre = Liste.filter((data) => data.T_ID == FactID);
       
      let totTr = 0
      TranchesAre.map((data) => {
          totTr = totTr + data.value
      })
      return (realTot - totTr)
    }
    const UpdateRealStock = (FID,Reste) =>{
      axios.post(`${GConf.ApiLink}/facture/modifier-reste`, {
          FID : FID,
          Reste : Reste,
      })
      .then(function (response) {      
          toast.success("Reste Modifier  !", GConf.TostSuucessGonf)
      }).catch((error) => {
          if(error.request) {
          toast.error(<><div><h5>Probleme de Connextion</h5> Operation Annuleé  </div></>, GConf.TostInternetGonf)   
          }
      });

  }

    const StateCard = ({ Reste, RealReste }) => {
      const Badge = ({ color, text }) => <span className={`badge bg-${color}`}>{text}</span>;
    
      const statusCard = () => {
        if (Reste === RealReste) {
          return <Badge color="success" text="OK" />;
        } else if (Reste !== RealReste) {
          return <Badge color="danger" text="NO" />;
        } else {
          return <Badge color="secondary" text="Indefinie" />;
        }
      };
    
      return (
        <div className="container">
          {statusCard()}
        </div>
      );
    };
    

    /*#########################[Card]##################################*/
    const CaisseCard = (props)=>{
      return(<>
         <div className='text-left'><span className='badge bg-system-btn p-2'>{props.caisseText}</span> </div>
      </>)
    }
    
    return (<>
        <Fade>
            
            <TableGrid tableData={facturesList} columns={['*','ID', 'Client','Jour','Temps','Etat','X','Voir','Voir']} />
        </Fade>
        <Modal
                size='small'
                open={modalS}
                closeIcon
                onClose={() => setModalS(false)}
                onOpen={() => setModalS(true)}
            >
                <Modal.Header><h4>{selectedArticle.Name}</h4></Modal.Header>
                <Modal.Content scrolling>

                        <table className='table table-striped'>
                            <thead>
                                <tr>
                                <th scope="col">No</th>
                                <th scope="col">Designiation</th>
                                <th scope="col">Qté</th>
                                <th scope="col">PUHT</th>
                                <th scope="col">PUTTC</th>
                                <th scope="col">Prix Net</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                selectedArticle.Articles ? 
                                <>
                                {
                                    JSON.parse(selectedArticle.Articles).map( (data,index) => 
                                        <tr key={index +1 }>
                                            <th scope="row">{index +1 }</th>
                                            <td>{data.Name}</td>
                                            <td>{data.Qte}</td>
                                            <td>{GConf.DefaultTva} %</td>
                                            <td>{data.Prix ? data.Prix.toFixed(3) : ''}</td>
                                            <td>{data.PU}</td>
                                        </tr>
                                    )
                                }
                                </>
                                :
                                <>
                                </>
                            }
                            </tbody>
                        </table> 
                </Modal.Content>
                <Modal.Actions>
                            <Button className='rounded-pill' negative onClick={ () => setModalS(false)}> <span className='bi bi-x' ></span> Fermer</Button>
                            <Button className='rounded-pill bg-system-btn'   onClick={ (e) => NavigateFunction(`/S/ft/info/${selectedArticle.T_ID}`)}><span className='d-none d-lg-inline'> Info </span><Icon  name='angle right' /></Button>
                </Modal.Actions>
        </Modal>
    </>);
}

export default FacturePage;